module.exports = __webpack_public_path__ + "static/media/photo166.7b67fae2.jpg";